// Generated by scripts/build-manifest.ts. Do not edit.
//
// Listed entries only. This file is bundled into the public SPA, so it must never carry the
// slugs of unlisted docs or decks — those stay private to the worker bundle.
import type { DeckMeta, DocMeta } from "@ming/shared";

export const publicDocs: readonly DocMeta[] = [
  {
    "slug": "typecheck-the-loop-b0ubyc",
    "title": "Typecheck the loop",
    "description": "Why TypeScript is non-negotiable for agentic web development.",
    "date": "2026-09-09",
    "tags": [
      "typescript",
      "ai",
      "tooling"
    ],
    "visibility": "listed",
    "kicker": "AI coding"
  }
];

export const publicDocsBySlug: ReadonlyMap<string, DocMeta> = new Map(
  publicDocs.map((doc) => [doc.slug, doc]),
);

export const publicDecks: readonly DeckMeta[] = [
  {
    "slug": "qmenut-technical-architecture-mjibm0",
    "title": "Architecting Web Apps in the Age of AI",
    "description": "Qmenut: product constraints, a modular backend, and the engineering decisions behind a live niche SaaS.",
    "date": "2026-08-21",
    "tags": [
      "architecture",
      "ai-assisted-development",
      "multitenancy",
      "production"
    ],
    "visibility": "listed",
    "kicker": "ENGINEERING CASE STUDY",
    "type": "presentation",
    "sheets": [
      {
        "file": "deck",
        "title": "Architecting Web Apps in the Age of AI"
      },
      {
        "file": "01-context",
        "title": "A modular backend is a practical starting point"
      },
      {
        "file": "02-typed-contracts",
        "title": "The typed contract starts at the database"
      },
      {
        "file": "03-visual-engine",
        "title": "Five identities, one component system"
      },
      {
        "file": "04-tenant-isolation",
        "title": "Sharing infrastructure requires explicit tenant scope"
      },
      {
        "file": "05-ai-development",
        "title": "AI needs a feedback loop and a complexity budget"
      },
      {
        "file": "06-production",
        "title": "Production readiness extends beyond the product"
      }
    ]
  }
];

export const publicDecksBySlug: ReadonlyMap<string, DeckMeta> = new Map(
  publicDecks.map((deck) => [deck.slug, deck]),
);
